export const COMMON = {
  CHAT_LINK: "chat.link",
  CHAT_PHOTO: "chat.photo",
  CHAT_VIDEO: "chat.video.msg",
  CHAT_FILE: "share.file",
  PIN_MESSAGE: "action.groupchat.jump.msg",
  UNPIN_MESSAGE: "action.open.grouptopic.detail",
  WEBCHAT: "webchat",
  ACTION_OPEN_PINBOARD: "action.open.pinboard",
  LOADING_FILE: "LOADING_FILE"

};